import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {lastValueFrom} from "rxjs";
import {Router} from "@angular/router";
import {NzMessageService} from "ng-zorro-antd/message";
import {PerFormaAPIService} from "src/app/services/pfapi.service";
import {PerformaModulesService} from "src/app/services/performa-modules.service";
import {AiStatuses} from "src/app/models/performa-enums";

@Component({
    selector: "app-ai-setting",
    templateUrl: "./ai-setting.component.html",
    styleUrl: "./ai-setting.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AiSettingComponent implements OnInit {
    constructor(
        private readonly api: PerFormaAPIService,
        private readonly router: Router,
        private readonly message: NzMessageService,
        private readonly modules: PerformaModulesService
    ) {}

    loading = true;
    aiStatus: number = AiStatuses.Off;

    // precomputed template bindings (no expressions/calls in the template)
    aiRequested = false; // status === Requested
    aiToggleOn = false; // status > Off (Requested or Active)
    aiReadonly = false; // can only toggle from the Off state

    async ngOnInit() {
        this.aiStatus = await this.modules.AiStatus();
        this.updateState();
        this.loading = false;
    }

    private updateState() {
        this.aiRequested = this.aiStatus === AiStatuses.Requested;
        this.aiToggleOn = this.aiStatus > AiStatuses.Off;
        this.aiReadonly = this.aiStatus !== AiStatuses.Off;
    }

    async enable() {
        // only meaningful from the Off state; once requested/active the toggle is read-only
        if (this.aiStatus !== AiStatuses.Off) return;
        this.loading = true;

        await lastValueFrom(this.api.postApiConfigureRequestAi())
            .then(() => {
                // the admin must now accept the AI terms on the consent page
                this.router.navigateByUrl("/account/consent");
            })
            .catch((error: any) => {
                console.log(error);
                this.message.error(error?.error ?? "Unable to request AI");
            })
            .finally(() => {
                this.loading = false;
            });
    }
}
